import { render, staticRenderFns } from "./SizeRowPreview.vue?vue&type=template&id=70ee682e&"
import script from "./SizeRowPreview.vue?vue&type=script&lang=js&"
export * from "./SizeRowPreview.vue?vue&type=script&lang=js&"
import style0 from "./SizeRowPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports